export default __webpack_public_path__ + "static/media/partner-name.dcc54b58.svg";